(function() {
  document.querySelectorAll('.card').forEach(card => {
    // Clean all .card__information a inside this card
    card.querySelectorAll('.card__information a').forEach(link => {
      link.textContent = link.textContent.replace('Smart Fortune Cookie™ - ', '');
    });

    const allContents = Array.from(card.querySelectorAll('.card__content'));
    const inner = card.querySelector('.card__inner');

    if (allContents.length > 0 && inner) {
      // Move the first .card__content above .card__inner
      const firstContent = allContents[0];
      card.insertBefore(firstContent, inner);

      // Remove all other .card__content elements except the first one
      allContents.slice(1).forEach(content => content.remove());
    }
  });
})();
